import { gql } from "@apollo/client";

export const FEATURED_FLIGHT = gql`
    query FeaturedFlight($culture: String!) {
        featuredFlight(where: {localization: {culture: $culture}}) {
        baseCity {
            contentItems {
            __typename
            ... on City {
                code {
                code
                }
                name
            }
            }
        }
        routes {
            contentItems {
            __typename
            ... on Route {
                code {
                code
                }
                weekSchedule {
                friday
                monday
                saturday
                sunday
                thursday
                tuesday
                wednesday
                }
            }
            }
        }
        }
    }  
`